import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=350fc97f&scoped=true"
import script from "./AlertComponent.ts?vue&type=script&lang=ts&external"
export * from "./AlertComponent.ts?vue&type=script&lang=ts&external"
import style0 from "./AlertComponent.scss?vue&type=style&index=0&id=350fc97f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350fc97f",
  null
  
)

export default component.exports